module.exports = __webpack_public_path__ + "img/agricultura_familiar_bronze.70183d5b.png";